module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('blockquote', {
    class: ("blockquote blockquote--" + _vm.alignClass)
  }, [_c('div', {
    staticClass: "blockquote__quote",
    domProps: {
      "innerHTML": _vm._s(_vm.quote)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "blockquote__source",
    domProps: {
      "innerHTML": _vm._s(_vm.source)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37b0d2e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/Blockquote.vue
// module id = 77
// module chunks = 0